export default __webpack_public_path__ + "static/media/a1.fd8e87c2.png";